
<div class="dialog-header">

    <h2 fxLayoutAlign="center center" mat-dialog-title translate="performance.labels.venueSeatPlan"></h2>

    <!--    -->
    <button class="close-button" [matTooltip]="'shared.labels.close'|translate"
        [mat-dialog-close]="false" mat-icon-button>
        <mat-icon>close</mat-icon>
    </button>

</div>


<mat-dialog-content>
    <img [src]="seatPlanImage" loading="lazy" class="event-seat-plan-image" alt="Venue Seat Plan">
</mat-dialog-content>